import { useMonitor } from '../use-monitor';

export function useMonitorApproveIssueSubmit() {
  return useMonitor('approve-issue-submit');
}
